/* ConvertMate 24-oct-2026 · HCE IOX H2 · Cajón del carrito (Figma V3 1209:4201)
   - Se define como <cart-drawer> para que product-form.js de Dawn lo use (getSectionsToRender / renderContents).
   - API global: window.CMCart.open() · .close() · .refresh() · .add(variantId, qty)
   - Cualquier fetch/XHR a /cart/add|change|update|clear hecho por otro script (secciones cm-, apps) refresca el cajón;
     si fue un "add", además lo abre. */
(() => {
  if (customElements.get('cart-drawer')) return; // Dawn ya registró su cajón (tipo de carrito = Cajón): no competir.

  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const lock = (on) => document.documentElement.classList.toggle('cm-scroll-lock', on);
  const OWN = 'X-CM-Cart';
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  const isCartPage = () => /\/cart\/?$/.test(location.pathname);

  class CmCartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.sectionId = this.dataset.sectionId;
      this.root = (window.Shopify && Shopify.routes && Shopify.routes.root) || this.dataset.root || '/';
      if (!this.root.endsWith('/')) this.root += '/';
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog || e.target.closest('[data-cm-cart-close]')) return this.close();
        const q = e.target.closest('[data-cm-qty]');
        if (q) return this.change(Number(q.dataset.line), Number(q.dataset.cmQty));
        const up = e.target.closest('[data-cm-upsell]');
        if (up) { up.setAttribute('aria-busy', 'true'); return this.add(up.dataset.cmUpsell, 1); }
      });
      this.dialog.addEventListener('change', (e) => {
        const input = e.target.closest('.cm-cart__qty-input');
        if (!input) return;
        const v = Math.max(0, parseInt(input.value, 10) || 0);
        this.change(Number(input.dataset.line), v);
      });
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });
      window.CMCart = {
        open: (el) => this.open(el),
        close: () => this.close(),
        refresh: () => this.refresh(),
        add: (id, qty) => this.add(id, qty),
      };
      if (typeof window.subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        window.subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
          if (ev && (ev.source === 'cm-cart' || ev.source === 'product-form')) return;
          this.refresh();
        });
      }
    }

    /* --- contrato con product-form.js de Dawn --- */
    getSectionsToRender() { return [{ id: this.sectionId, section: this.sectionId, selector: '.cm-cart__inner' }]; }
    setActiveElement(el) { this.activeElement = el; }
    renderContents(parsed) {
      const html = parsed && parsed.sections && parsed.sections[this.sectionId];
      if (html) this.apply(html); else this.refresh();
      this.skipNext = Date.now();
      this.open();
    }

    open(trigger) {
      if (trigger) this.activeElement = trigger;
      else if (!this.activeElement) this.activeElement = document.activeElement;
      if (this.dialog.open) return;
      this.dialog.showModal();
      lock(true);
      const closeBtn = this.dialog.querySelector('[data-cm-cart-close]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
      requestAnimationFrame(() => requestAnimationFrame(() => this.dialog.classList.add('is-open')));
    }
    close() {
      if (!this.dialog.open) return;
      this.dialog.classList.remove('is-open');
      const done = () => {
        if (this.dialog.open) this.dialog.close();
        lock(false);
        const back = this.activeElement;
        this.activeElement = null;
        if (back && back.isConnected && typeof back.focus === 'function') back.focus({ preventScroll: true });
      };
      if (reduced()) done(); else setTimeout(done, 280);
    }

    apply(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.cm-cart__inner');
      const current = this.querySelector('.cm-cart__inner');
      if (!fresh || !current) return;
      const hadFocus = document.activeElement && current.contains(document.activeElement)
        ? (document.activeElement.dataset.line ? `[data-line="${document.activeElement.dataset.line}"].${[...document.activeElement.classList].join('.')}` : '[data-cm-cart-close]')
        : null;
      current.replaceWith(fresh);
      const count = Number(fresh.dataset.cmCount) || 0;
      this.classList.toggle('is-empty', count === 0);
      document.dispatchEvent(new CustomEvent('cm:cart:count', { detail: { count } }));
      if (hadFocus && this.dialog.open) {
        let el = null;
        try { el = fresh.querySelector(hadFocus); } catch (e) {}
        el = el || fresh.querySelector('[data-cm-cart-close]');
        if (el) el.focus({ preventScroll: true });
      }
    }

    async refresh() {
      try {
        const r = await fetch(`${this.root}?sections=${encodeURIComponent(this.sectionId)}`, { headers: { [OWN]: '1' } });
        const data = await r.json();
        if (data && data[this.sectionId]) this.apply(data[this.sectionId]);
      } catch (e) { console.error('[cm-cart] refresh', e); }
    }

    setBusy(on) { this.dialog.classList.toggle('is-busy', on); this.dialog.setAttribute('aria-busy', on ? 'true' : 'false'); }

    showError(msg) {
      const el = this.querySelector('[data-cm-cart-error]');
      if (!el) return;
      el.textContent = msg || (window.cartStrings && cartStrings.error) || 'No pudimos actualizar el carrito. Intenta de nuevo.';
      el.hidden = false;
    }

    async post(path, body) {
      const r = await fetch(`${this.root}${path}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', [OWN]: '1' },
        body: JSON.stringify({ ...body, sections: [this.sectionId], sections_url: location.pathname }),
      });
      const data = await r.json();
      if (!r.ok || data.status) throw data;
      return data;
    }

    async change(line, quantity) {
      if (!line) return;
      this.setBusy(true);
      try {
        const data = await this.post('cart/change.js', { line, quantity });
        if (data.sections && data.sections[this.sectionId]) this.apply(data.sections[this.sectionId]); else await this.refresh();
        this.publish(data);
        if (isCartPage()) location.reload();
      } catch (err) {
        await this.refresh();
        this.showError(err && (err.description || err.message));
      } finally { this.setBusy(false); }
    }

    async add(id, quantity = 1) {
      if (!id) return;
      this.setBusy(true);
      try {
        const data = await this.post('cart/add.js', { items: [{ id: Number(id), quantity: quantity || 1 }] });
        if (data.sections && data.sections[this.sectionId]) this.apply(data.sections[this.sectionId]); else await this.refresh();
        this.publish(data);
        this.open();
      } catch (err) {
        this.open();
        this.showError(err && (err.description || err.message));
      } finally { this.setBusy(false); }
    }

    publish(data) {
      if (typeof window.publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { window.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cm-cart', cartData: data }); } catch (e) {}
      }
    }

    /* Llamado por el interceptor cuando otro script tocó el carrito. */
    external(isAdd) {
      clearTimeout(this.extTimer);
      this.extTimer = setTimeout(async () => {
        if (this.skipNext && Date.now() - this.skipNext < 1500) { this.skipNext = 0; return; }
        await this.refresh();
        if (isAdd && !isCartPage()) this.open();
      }, 60);
    }
  }
  customElements.define('cart-drawer', CmCartDrawer);

  /* --- Interceptor: otros scripts que agregan/cambian el carrito --- */
  const notify = (url, ok) => {
    if (!ok || !CART_RE.test(url)) return;
    const d = document.querySelector('cart-drawer');
    if (d && typeof d.external === 'function') d.external(/\/cart\/add/.test(url));
  };
  const hasOwnHeader = (init) => {
    const h = init && init.headers;
    if (!h) return false;
    if (typeof Headers !== 'undefined' && h instanceof Headers) return h.has(OWN);
    return Object.keys(h).some((k) => k.toLowerCase() === OWN.toLowerCase());
  };
  const rendersSections = (init) => {
    // product-form.js de Dawn pide las secciones y llama a renderContents: no duplicar.
    const b = init && init.body;
    return typeof FormData !== 'undefined' && b instanceof FormData && b.has('sections');
  };
  const nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = nativeFetch.apply(this, arguments);
    if (CART_RE.test(url) && !hasOwnHeader(init) && !rendersSections(init)) {
      p.then((r) => notify(url, r.ok)).catch(() => {});
    }
    return p;
  };
  const xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._cmUrl = String(url || '');
    return xOpen.apply(this, arguments);
  };
  const xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (CART_RE.test(this._cmUrl || '')) {
      this.addEventListener('load', () => notify(this._cmUrl, this.status >= 200 && this.status < 300));
    }
    return xSend.apply(this, arguments);
  };

  /* --- Editor de temas: seleccionar la sección abre el cajón --- */
  document.addEventListener('shopify:section:select', (e) => {
    const d = document.querySelector('cart-drawer');
    if (d && e.target.contains(d)) d.open();
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const d = document.querySelector('cart-drawer');
    if (d && e.target.contains(d)) d.close();
  });
})();
